import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Demo() {
  const apiURL = process.env.REACT_APP_API_URL || "http://localhost:5000";
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchDemoUser() {
      try {
        const res = await fetch(`${apiURL}/users/demo`);
        const data = await res.json();

        if (data.user) {
          sessionStorage.setItem("loggedIn", true);

          navigate("/skedesplaner", {
            state: {
              user: data.user,
              userList: [data.user],
            },
          });
        } else {
          console.error("No user returned");
        }
      } catch (err) {
        console.error("Failed to fetch demo user:", err);
      }
    }

    fetchDemoUser();
  }, [navigate]);

  return <p>Loading demo...</p>;
}
